import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {FileManagerService} from '../../main/file-manager/file-manager.service';
import {AWSPollyFile} from '../../models/AWS_Polly_TTS_File';
import {AWSPollyVoiceData} from '../../services/AWS_PollyVoiceData.Service';
import {AACFileInfo} from '../../models/AAC_FileInfo';



@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './polly-prompt-save-dialog.component.html',
    styleUrls: ['./polly-prompt-save-dialog.component.scss']
})

export class PollyPromptSaveDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    statusMessage: any;
    hideOverwrite: any;
    proccessingFileName: any;
    progressMode = 'determinate';

    constructor(
        private dialogRef: MatDialogRef<PollyPromptSaveDialogComponent>,
        public _fileManagerService: FileManagerService,
        private _polyVData: AWSPollyVoiceData,
        @Inject(MAT_DIALOG_DATA) public data: PolyPromptSaveDialogModel
    ) {

    }

    ngOnInit(): void {
        let beginOverWrite = 'None';
        if (this.data.overwriteByDefault){
            beginOverWrite = 'All';
        }
        this.processBatchTTS(this.data.pollyProcessList, 0, beginOverWrite).then( (processResult) => {
            if (processResult)
                {
                    this.dialogRef.close(true);
                }
            }
        );
    }


    async processBatchTTS(batchArray: AWSPollyFile[], startIndex = 0, overWrite = 'None'): Promise<any> {
        this.totalProcessCount = batchArray.length;
        for (let _i = startIndex; _i < batchArray.length; _i++) {
            this.hideOverwrite = true;
            this.progressMode = 'determinate';
            const ttsData = batchArray[_i];
            this.completeProgress = Math.round((_i + 1) * 100 / batchArray.length);
            this.currentProcessIndex = _i;
            this.proccessingFileName = ttsData.filePath;
            let createSuccess = false;
            const fileData = await this._polyVData.pollySynthesis(ttsData.voice , ttsData.message);
            let curOverWrite = false;
            switch (overWrite)
            {
                case 'None':
                {
                    curOverWrite = false;
                    break;
                }
                case 'All':
                {
                    curOverWrite = true;
                    break;
                }
                case 'Current':
                {
                    curOverWrite = true;
                    overWrite = 'None';
                    break;
                }
            }
            const createResult = await this._fileManagerService.uploadFile(ttsData.filePath, fileData.ttsFile.file, curOverWrite).then( () => {createSuccess = true; })
                .catch((error) => {
                    this.statusMessage = error.aac_error;
                    if (error.error.error_description === 'FileExists')
                    {
                        this.hideOverwrite = false;
                        this.progressMode = 'indeterminate';
                    }
                    else {
                        this.dialogRef.close(error);
                    }
                });
            if (!createSuccess){
                return false;
            }
            let updateInfoResult = false;
            const ttsFileInfo = new AACFileInfo();
            ttsFileInfo.voiceId = ttsData.voice.voiceId;
            ttsFileInfo.fileTranscription =  ttsData.message;
            ttsFileInfo.filePath = ttsData.filePath;
            ttsFileInfo.fileName = ttsData.filePath.substr(ttsData.filePath.lastIndexOf('/') + 1);
            ttsFileInfo.filePath = ttsData.filePath.substr(0, ttsData.filePath.lastIndexOf('/') + 1);
            if (ttsFileInfo.filePath.length > 1)
            {
                ttsFileInfo.filePath = ttsFileInfo.filePath.substr(0, ttsFileInfo.filePath.length - 1);
            }
            await this._fileManagerService.saveFileInfo(ttsFileInfo).then( () => {updateInfoResult = true; })
                .catch((error) => {
                    const errorType = error.fileErrorType;
                    this.dialogRef.close(error);
                });
        }
        return true;
    }

    cancelProcess(): void {
        this.dialogRef.close(false);
    }

    skipFile(): void {
        this.processBatchTTS(this.data.pollyProcessList, this.currentProcessIndex + 1).then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }

    overwriteFile(): void {
        this.processBatchTTS(this.data.pollyProcessList, this.currentProcessIndex, 'Current').then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }

    overwriteAll(): void {
        this.processBatchTTS(this.data.pollyProcessList, this.currentProcessIndex, 'All').then( (processResult) => {
            if (processResult)
            {
                this.dialogRef.close(true);
            }
        });
    }
}

export class PolyPromptSaveDialogModel {
    constructor(
        public pollyProcessList: AWSPollyFile[],
        public overwriteByDefault: boolean,
    )
    {

    }
}


